import { Component, Prop } from 'vue-property-decorator';
import ApeironComponent from '@/components/commons/apeiron-component.model';
import { Solucion } from '@/shared/model/solucion.model';
import { Solicitud } from '@/shared/model/solicitud.model';
import OpcionesTerminalesListado from '@/entities/snp/solicitud/posgrado/opcionesTerminales/opciones-terminales-listado.vue';
import OpcionesTerminalesRegistro from '@/entities/snp/solicitud/posgrado/opcionesTerminales/opciones-terminales-registro.vue';
import { OpcionTerminalSnp } from '@/shared/model/snp/opcion-terminal.model';
@Component({
  components: {
    'opciones-terminales-registro': OpcionesTerminalesRegistro,
    'opciones-terminales-listado': OpcionesTerminalesListado,
  },
})
export default class OpcionesTerminalesComponent extends ApeironComponent {
  @Prop({ required: true })
  public solucion: Solucion;

  @Prop({ required: true })
  public solicitud: Solicitud;

  public esVisibleRegistro = false;
  public esVisibleListado = true;

  public opcionTerminalEdicion: OpcionTerminalSnp = new OpcionTerminalSnp();
  public opcionTerminalAgregar: OpcionTerminalSnp = new OpcionTerminalSnp();

  public editarOpcionTerminal(opcionTerminal: OpcionTerminalSnp): void {
    this.opcionTerminalEdicion = { ...opcionTerminal };
    this.esVisibleRegistro = true;
    this.esVisibleListado = false;
  }

  public agregarOpcionTerminalATabla(opcionTerminal: OpcionTerminalSnp): void {
    this.esVisibleRegistro = false;
    this.esVisibleListado = true;
    this.opcionTerminalAgregar = { ...opcionTerminal };
  }

  /**
   * Indicador para permitir el modo escritura
   */
  get esEscritura(): boolean {
    return this.esEscrituraConEstadoEnCaptura(this.solicitud.estado);
  }
}
